import { useUser } from "@features/user/use-user";
import { fetchServer } from "@features/utils";
import { useState } from "react";
import { useQueryClient } from "react-query";
import { useParams } from "react-router-dom";

export const useImportImage = () => {
  const client = useQueryClient();
  const { refresh } = useUser();
  const [loading, setLoading] = useState(false);
  const { site, id: urlProjectId } = useParams();

  return {
    loading,
    importImage: async (file: File, projectId?: string) => {
      setLoading(true);
      try {
        // Convert file to base64
        const base64 = await new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => {
            if (typeof reader.result === "string") {
              resolve(reader.result);
            } else {
              reject(new Error("FileReader result is not a string"));
            }
          };
          reader.onerror = () => {
            reject(new Error("FileReader encountered an error"));
          };
          reader.readAsDataURL(file);
        });

        // Send to import endpoint
        const result = await fetchServer("/api/images/import", {
          image: base64,
          site,
          project_id: projectId || urlProjectId || null,
        });

        // Invalidate queries to refresh the UI
        client.invalidateQueries(["images", "list"]);
        refresh(); // Refresh credits (even though import is free, user data might have changed)

        return result;
      } finally {
        setLoading(false);
      }
    },
  };
};
